import styled from "styled-components";
import type { UscObjectFitType } from "../../../../../shared-logic/types/UscCommonTypes";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Image = styled.img<{ objectFit: UscObjectFitType; show: boolean }>`
    position: relative;
    aspect-ratio: 16/9;
    object-fit: ${({ objectFit }) => objectFit};
    width: 100%;
    border-radius: 8px;

    &[data-aspect-ratio="4:3"] {
        aspect-ratio: 4/3;
    }
`;

export const Wrapper = styled.div<{ singleImage: boolean }>`
    position: relative;
    min-width: calc(100vw - (var(--spacing-2) * 2));
    scroll-snap-align: center;

    &:first-child {
        margin-left: ${({ singleImage, theme }) => !singleImage && !theme.isRTL && "24px"};
        margin-right: ${({ singleImage, theme }) => !singleImage && theme.isRTL && "24px"};
    }

    &:last-child img {
        margin-left: ${({ singleImage, theme }) => !singleImage && theme.isRTL && "50%"};
        margin-right: ${({ singleImage, theme }) => !singleImage && !theme.isRTL && "50%"};
    }

    @media screen and (min-width: ${breakpoints.md}) {
        min-width: calc(100vw - (var(--spacing-3) * 2));
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        min-width: 100%;
        cursor: pointer;

        &:first-child {
            margin-left: ${({ singleImage, theme }) => !singleImage && !theme.isRTL && 0};
            margin-right: ${({ singleImage, theme }) => !singleImage && theme.isRTL && 0};
        }
    }
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: all;
`;

export const Loader = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background: var(--color-platinum-light);
`;
